<template>
  <div
    :ref="controlRef"
    class="ms-organization-unit-1"
    :style="setWidth"
  >
    <div
      v-show="editingMode"
      class="flex-col w-full"
    >
      <div
        class="ms-combobox flex h-32 p-relative"
        :class="[
          { 'isValidOrg p-relative': errorProvider.isValid },
          { 'mode-multiple': mode == 'multiple' },
        ]"
        style="width: 100%"
        :style="setWidth"
      >
        <div class="ms-organization-unit">
          <DxDropDownBox
            ref="dropdown"
            :value="valueX"
            :disabled="disabled"
            :show-clear-button="false"
            :data-source="dataSource"
            class="ms-dropdown-box"
            value-expr="OrganizationUnitID"
            display-expr="OrganizationUnitName"
            :placeholder="placeholder"
            :field-template="mode == 'multiple' ? 'list-item' : 'item'"
            :tab-index="1"
            :drop-down-options="dropDownOptions"
          >
            <template
              v-if="mode == 'multiple'"
              #list-item="{ data }"
            >
              <div
                class="multiple-select"
                :class="{ 'p-l-24': isShowIconControl }"
              >
                <div
                  v-if="isShowIconControl"
                  class="icon-organization-control"
                >
                  {{ data }}
                </div>
                <DxTextBox
                  ref="textbox"
                  :placeholder="placeholder"
                  :class="listData.length > 0 ? 'h-0' : ''"
                  :tab-index="1"
                />
                <!-- Multiple value -->
                <div
                  v-if="listData.length > 0"
                  id="input"
                  class="selected-options"
                >
                  <div
                    v-for="(item, index) in listData"
                    :key="index"
                    class="selected-item"
                    :title="item['OrganizationUnitName']"
                  >
                    <div class="item-text m-r-8">
                      {{ item["OrganizationUnitName"] }}
                    </div>
                    <div
                      v-show="!disabled"
                      class="item-icon icon-remove cursor-pointer"
                      @click="removeItem(item)"
                    />
                  </div>
                </div>
              </div>
            </template>
            <template
              v-if="mode != 'multiple'"
              #item="{}"
            >
              <div
                :title="itemSelectedName"
                class="text-box"
              >
                <div
                  v-if="isShowIconControl"
                  class="icon-organization-control"
                />
                <DxTextBox
                  ref="textbox"
                  :value="itemSelectedName"
                  :placeholder="placeholder"
                  :show-clear-button="false"
                  :disabled="true"
                />
                <div
                  v-show="
                    valueX && valueX.length && valueX[0] && showClearButton
                  "
                  class="icon-remove"
                  style="margin-top: 10px"
                  @click="clearValue"
                />
              </div>
            </template>
            <template #content="{}">
              <div
                :style="'height: ' + heightPopup + 'px'"
                :class="['dropdown-content-organization']"
              >
                <div class="m-b-16">
                  <ms-input
                    icon="mi-search mi-search"
                    :placeholder="$t('i18nCommon.Search')"
                    width="100%"
                    @changed="onSearch"
                  />
                </div>
                <DxTreeView
                  ref="treeview"
                  :search-enabled="true"
                  :search-value="searchValue"
                  :search-expr="[
                    'OrganizationUnitName',
                    'OrganizationUnitSearch',
                  ]"
                  :select-by-click="true"
                  data-structure="plain"
                  key-expr="OrganizationUnitID"
                  parent-id-expr="ParentID"
                  :selection-mode="mode"
                  expanded-expr="IsExpanded"
                  :height="showInactive ? 'calc(100% - 60px)' : '100%'"
                  display-expr="OrganizationUnitName"
                  :no-data-text="
                    isLoading
                      ? $t('i18nCommon.LoadingData')
                      : $t('i18nCommon.DataEmpty')
                  "
                  :search-editor-options="{
                    placeholder: $t('i18nCommon.Search'),
                  }"
                  has-items-expr="IsParent"
                  :data-source="dataSource"
                  item-template="itemTemplate"
                  @itemClick="selectItem"
                  @content-ready="contentReady"
                >
                  <DxSearchEditorOptions
                    :visible="false"
                  />
                  <template #itemTemplate="{ data }">
                    <div
                      :title="data.OrganizationUnitName"
                      :class="[
                        'item-org flex items-center wrap-text',
                        { 'org-active': data.Selected },
                      ]"
                    >
                      <!--  :style="[{ color: data.Inactive ? '#9E9E9E' : true }]" -->
                      <div
                        v-show="mode == 'multiple'"
                        v-if="data.Selected"
                        class="mi-square-check-primary m-r-4"
                      />
                      <div
                        v-show="mode == 'multiple'"
                        v-else
                        class="mi-square-default m-r-4"
                      />
                      <div class="hide-content">
                        {{ data.OrganizationUnitName }}
                      </div>
                    </div>
                  </template>
                </DxTreeView>
                <!-- <ms-loading v-if="loadingData" color="blue" scale="0.5" background="white" :isDescription="true" ></ms-loading> -->
                <div
                  v-if="showInactive"
                  :class="['org-inactive', { 'color-active': inactive }]"
                >
                  <ms-checkbox
                    v-model="inactive"
                    @changed="changeInactive"
                  >
                    <div>
                      {{ $t("i18nCommon.ShowOrganizationUnitInactive") }}
                    </div>
                  </ms-checkbox>
                </div>
              </div>
            </template>
          </DxDropDownBox>
          <!-- <ms-tooltip
            v-if="!disabled && errorProvider.isValid"
            class="icon-input-tree-select"
            :showTooltips="false"
          >
            <div>
              <div class="mi mi-20 mi-icon-error mr-2"></div>
            </div>
          </ms-tooltip> -->
        </div>
        <!-- Mode sửa nhanh -->
        <div
          v-if="editable"
          class="flex m-l-8"
        >
          <ms-icon
            icon="mi-file-green"
            :tooltip-content="$t('i18nCommon.Save')"
            @click="saveEditMode"
          />
          <ms-icon
            icon="mi-circle-close-red"
            :tooltip-content="$t('i18nCommon.Cancel2')"
            @click="closeEditMode"
          />
        </div>
      </div>
    </div>
    <div v-if="listData.length > 0 && showList">
      <DxList
        :data-source="listData"
        :height="DxListHeight"
        :width="'100%'"
        :class="{ 'max-height': DxListHeight == 'auto' }"
        :no-data-text="$t('i18nCommon.DataEmpty')"
        style="border: 1px solid #e0e0e0; border-top: none; margin-top: -1px"
      >
        <template #item="{ data }">
          <div class="item-wrap-ms-organization">
            <div class="item-wrap-detail w-full flex">
              <div
                class="item-name flex m-r-24"
                style="width: calc(100% - 60px) !important"
              >
                <slot
                  name="list"
                  :data="data"
                />
              </div>
              <i
                class="mi-close"
                style="background-color: red !important"
                @click="removeItem(data)"
              />
            </div>
          </div>
        </template>
      </DxList>
    </div>
    <div
      v-show="editable && !editingMode"
      class="flex"
      @dblclick="onDoubleClick"
    >
      <ms-text-border class="text-border">
        <slot name="text">
          <span :title="internalText">{{ internalText }}</span>
        </slot>
        <template #icon>
          <ms-icon
            v-if="permission"
            icon="mi-pencil"
            :tooltip-content="$t('i18nCommon.Edit')"
            @click="clickEditBtn"
          />
          <ms-icon
            v-if="!permission"
            icon="mi-lock"
          />
        </template>
      </ms-text-border>
    </div>
    <p
      v-show="
        !disabled &&
          errorProvider.isValid &&
          ((editable && editingMode) || !editable)
      "
      :class="{ 'text-error': errorProvider.isValid }"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import DxDropDownBox from "devextreme-vue/drop-down-box";
import DxTreeView, { DxSearchEditorOptions } from "devextreme-vue/tree-view";
import OrganizationApi from "@/apis/components/OrganizationAPI.js";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import DxTextBox from "devextreme-vue/text-box";
import DxList from "devextreme-vue/list";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";
import i18n from "@/i18ns/i18n.js";

export default {
  name: "MsOrganizationUnit",
  components: {
    DxDropDownBox,
    DxTreeView,
    DxTextBox,
    DxList,
    DxSearchEditorOptions,
  },
  extends: msBaseComponent,
  props: {
    value: {
      type: [Array, Number],
      default: () => [],
    },
    //Khởi tạo các item ban đầu
    initItem: {
      type: [String, Array],
      default: null,
    },
    //Chế độ chọn đơn hay nhiều
    mode: {
      type: String,
      default: "single",
    },
    //Có hiển thị option hiển thị đơn vị ngừng hoạt động không
    showInactive: {
      type: [String, Boolean],
      default: true,
    },
    //Giá trị checkbox hiển thị đơn vị ngừng hoạt động
    inactiveValue: {
      type: [String, Boolean],
      default: false,
    },
    //Chiều rộng combo
    width: {
      type: [String, Number],
    },
    //Có disable hay không
    disabled: {
      type: [String, Boolean],
      default: false,
    },
    //Có lấy theo đơn vị cha không
    getUnitChild: {
      type: [String, Boolean],
      default: false,
    },
    paramValidate: Object,
    //Truyền vào ID đơn vị cha để lấy ra danh sách đơn vị con
    parentID: {
      type: [String, Number],
      default: null,
    },
    showList: {
      type: [String, Boolean],
      default: false,
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t("i18nCommon.SelectOrganizationUnit");
      },
    },
    DxListHeight: {
      type: [Number, String],
      default: "auto",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    //có focus ban đầu hay không
    autofocus: {
      type: [String, Boolean],
      default: false,
    },
    //có tự động chọn con hay không
    autochild: {
      type: [String, Boolean],
      default: true,
    },
    //Sử dụng trường OrgIDConvert làm khóa chính hay không
    useIDConvert: {
      type: [String, Boolean],
      default: false,
    },
    permission: {
      type: Boolean,
      default: true,
    },
    //Có hiển thị button clear giá trị không
    showClearButton: {
      type: Boolean,
      default: false,
    },
    //Mã phân hệ hiện tại theo bộ quyền
    subSystemCodeRole: {
      Type: String,
      default: "",
    },
    //Chức năng của phân hệ
    actionRole: {
      Type: String,
      default: "",
    },
    heightPopup: {
      Type: [String, Number],
      default: 414,
    },
    isShowIconControl: {
      Type: Boolean,
      default: false,
    },
    showOptionNoChoose: {
      Type: Boolean,
      default: false,
    },
    // thuộc tính dùng cho phần bộ lọc nâng cao CCTC option trống
    isUseEmptyOUOption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      controlRef: MsControlRef.MsOrganizationUnit,
      searchValue: "",
      dataSource: [],
      valueX: [],
      listData: [],
      internalText: "",
      inactive: false,
      isFirst: true, //lần đầu gọi api lấy dữ liệu
      isLoading: true, //lần đầu loading xong lấy ra dữ liệu
      oldValueX: [],
      changeValueInactive: false,
      loadingData: false,
      listOrgIDConvertInit: [],
      // set chế độ edit = fasle khi editable = true
      editingMode: !this.editable,
      oldValue: null,
      oldListData: [],
      itemSelectedName: "",
      dropDownOptions: null,
    };
  },
  computed: {
    setWidth() {
      if (!this.width) return {};
      return {
        width: !isNaN(this.width)
          ? this.width + "px !important"
          : this.width + " !important",
      };
    },
    isEditingMode() {
      return this.$store.getters.getEditingMode;
    },
  },
  watch: {
    /**
     * custom validate
     */
    paramValidate(val) {
      let me = this;
      //Nếu validate đang true và kphai custom thì return
      if (
        me.errorProvider &&
        me.errorProvider["isValid"] &&
        (!val || (val && me.errorProvider["rules"] != val.rules))
      ) {
        return;
      }

      if (val && val.isValid) {
        me.$set(me.errorProvider, "message", val.message);
        me.$set(me.errorProvider, "isValid", true);
        me.errorProvider.rules = val.rules;
        me.errorProvider.element = me.$refs.input;
      } else {
        me.errorProvider = {};
      }
    },
    autofocus: {
      handler(val) {},
    },
    value: {
      handler(val) {
        if (this.mode == "single") {
          if (typeof val == "number") {
            this.valueX = [val];
            this.oldValueX = [val];
          } else if (typeof val == "string") {
            // if (!this.useIDConvert) {
            //   val = parseInt(val);
            // }
            this.valueX = [val];
            this.oldValueX = [val];
          } else {
            this.valueX = this.$function._cloneDeep(val);
            this.oldValueX = this.$function._cloneDeep(val);
          }
          if (this.useIDConvert) {
            this.listOrgIDConvertInit = [val];
          }
        } else {
          this.valueX = val;
          if (this.useIDConvert) {
            this.listOrgIDConvertInit = val;
          }
        }
        if (this.isFirst && val) {
          if (this.useIDConvert) {
            var value = [...this.valueX];
            this.valueX = [];
            let me = this;
            value.forEach((ele, index) => {
              me.valueX.push(ele);
            });
          }
          this.initDataSouce();
        } else {
          if (this.useIDConvert) {
            var value = [...this.valueX];
            this.valueX = [];
            let me = this;
            value.forEach((ele) => {
              var item = me.dataSource.find((x) => x.OrgIDConvert == ele);
              me.valueX.push(item.OrganizationUnitID);
            });
          }
        }
        if (!val) {
          this.listData = [];
        }
        this.internalText = val;
        !this.isFirst && this.validate(this.internalText);
      },
      immediate: true,
    },
    initItem: {
      handler(val) {
        if (this.isFirst && val) {
          this.initDataSouce();
        }
      },
    },
    inactiveValue: {
      handler(val) {
        this.inactive = val;
      },
      immediate: true,
    },
    valueX: {
      handler(val) {
        if (!val || val.length == 0) {
          this.itemSelectedName = "";
        }
      },
    },
    dataSource(val) {
      var me = this;
      var oldValue = me.valueX ? me.valueX : [];
      var newValue = [];
      if (!me.useIDConvert) {
        oldValue &&
          oldValue.forEach((value) => {
            if (
              me.dataSource.findIndex((x) => x.OrganizationUnitID == value) !=
              -1
            ) {
              newValue.push(value);
            }
          });
      } else {
        me.listData = [];
        me.listOrgIDConvertInit &&
          me.listOrgIDConvertInit.forEach((value) => {
            me.dataSource.forEach((ele) => {
              if (ele.OrgIDConvert == value) {
                newValue.push(ele.OrganizationUnitID);
                ele["Selected"] = true;
                me.listData.push(ele);
              }
            });
          });
        me.valueX = [...newValue];
      }
      //Mở các nút cha chứa con được chọn
      this.valueX &&
        this.valueX.forEach((org) => {
          this.expandedNode(org);
        });
      if (newValue.length != oldValue.length) {
        me.valueX = newValue.length > 0 ? newValue : null;
        //Có sử dụng IDConvert hay không
        if (me.useIDConvert && me.valueX) {
          var listOrgIDConvert = [];
          me.listOrgIDConvertInit.forEach((ele) => {
            var itemConvert = me.dataSource.find((x) => x.OrgIDConvert == ele);
            listOrgIDConvert.push(itemConvert.OrgIDConvert);
          });
          me.$emit("input", listOrgIDConvert);
        } else {
          me.valueX = newValue.length > 0 ? newValue : null;
          me.$emit("input", me.valueX);
        }
      }
      //Hight light tất cả CCTC con chế độ multiple
      if (this.mode == "multiple" && !this.autochild) {
        this.valueX &&
          this.valueX.forEach((val) => {
            var org = this.dataSource.find((x) => x.OrganizationUnitID == val);
            //Chọn tất cả đơn vị con của đơn vị đang xét
            this.setValueChilds(org, true);
          });
      }
    },
    editable: {
      immediate: true,
      handler(val) {
        this.$store.dispatch("setEditingMode", false);
        this.editingMode = !val;
      },
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.dropdown.instance && this.$refs.dropdown.instance.focus();
      this.$refs.textbox.instance && this.$refs.textbox.instance.focus();
    }
    this.dropDownOptions = {
      onShown: function (args) {
        args.component
          .content()
          .parentElement.parentElement.classList.add("ms-dropdown-box");
      },
    };
  },
  created() {},
  methods: {
    /**
     * @override
     */
    focusError(){
      this.$refs.dropdown.instance.open();
    },
    /**
     * Hàm mở các nút cha chứa con được chọn
     * Created by CVCUONG1 - 9/8/2021
     */
    expandedNode(item) {
      var parent = this.dataSource.find((x) => x.OrganizationUnitID == item);
      if (parent) {
        parent["IsExpanded"] = true;
        this.expandedNode(parent);
      }
    },
    /**
     * Hàm xóa giá trị combo
     * Created by CVCUONG - 7/6/2021
     */
    clearValue() {
      this.value = null;
      this.valueX = null;
      this.itemSelectedName = null;
      this.$emit("input", null);
      this.dataSource.forEach((org) => {
        org.Selected = false;
      });
      const dropdown = this.$refs.dropdown.instance;
      dropdown.close();
      this.$emit("selected", null);
    },
    /**
     * Sự kiện khi search đơn vị áp dụng
     * createdBy: dmgiang (13/4/2021)
     */
    onSearch(data) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.searchValue = data; // this.stringToSlug(data);
      }, 300);
    },
    onDoubleClick() {
      this.permission && this.clickEditBtn();
    },
    /**
     * Hàm set Item khởi tạo
     * Created by CVCuong1 13/4/2021
     */
    setInitItem(organizationUnitID, organizationUnitName) {
      this.$store.dispatch("setDataOrganizationCommon", {});
      this.isFirst = true;
      this.value = organizationUnitID;
      this.valueX = [organizationUnitID];
      this.initItem = organizationUnitName;
      this.initDataSouce();
    },
    /**
     * Đưa combo về trạng thái ban đấu
     * Created cvcuong1 - 17/6/2021
     */
    reloadCombo() {
      this.isFirst = true;
    },
    /**
     * Khởi tạo list dataSource ban đầu khi chưa gọi api lấy dữ liệu về
     * Created by CVCUONG1 20/3/2021
     */
    initDataSouce() {
      const me = this;
      if (me.valueX && me.initItem && me.initItem.length > 0) {
        const initConvert = me.initItem.replaceAll(";", "#");
        const listInit = initConvert.split("#");
        me.dataSource = [];
        me.listData = [];
        me.valueX.forEach((item, index) => {
          let data;
          if (me.useIDConvert) {
            data = {
              OrganizationUnitID: item,
              OrganizationUnitName: listInit[index],
              OrgIDConvert: me.listOrgIDConvertInit[index],
            };
          } else {
            data = {
              OrganizationUnitID: item,
              OrganizationUnitName: listInit[index],
            };
          }
          if (
            me.dataSource.findIndex(
              (x) => x.OrganizationUnitID == data.OrganizationUnitID
            ) == -1
          ) {
            data["Selected"] = true;
            me.dataSource.push(data);
            me.listData.push(data);
          }
        });
      }
      if (me.mode == "single") {
        me.itemSelectedName =
          me.dataSource.length > 0 ? me.dataSource[0].OrganizationUnitName : "";
      }
    },
    /**
     * Hàm xử lý sự kiện chọn item
     * Created by CVCUONG1 - 27/2/2021
     */
    selectItem(data) {
      var item = data.itemData;
      if (this.mode == "single") {
        item.Selected = !item.Selected;
        if (item.Selected) {
          this.valueX = [item.OrganizationUnitID];
          //Kiểm tra xem  bắn lên OrganizationUnitID hay OrgIDConvert
          if (this.useIDConvert) {
            this.$emit("input", item.OrgIDConvert);
          } else {
            this.$emit("input", this.valueX[0]);
          }
          this.$emit("selected", item);
          this.dataSource.forEach((org) => {
            if (org.OrganizationUnitID == item.OrganizationUnitID) {
              org["Selected"] = true;
              this.itemSelectedName = item.OrganizationUnitName;
            } else {
              org["Selected"] = false;
            }
          });
        } else {
          this.$emit("selected", null);
          this.valueX = null;
          this.$emit("input", null);
        }

        const dropdown = this.$refs.dropdown.instance;
        dropdown.close();
      } else {
        if (!item.Selected) {
          item["Selected"] = true;
          this.$emit("selected", item);
          //Tìm tất cả con để chọn và nhận ID đơn vị con hay không
          if (this.autochild) {
            if (this.valueX) {
              this.valueX.push(item.OrganizationUnitID);
            } else {
              this.valueX = [];
              this.valueX.push(item.OrganizationUnitID);
            }
            //Hàm chọn tất cả đơn vị con và nhận ID đơn vị con vào list Data
            this.selectChildsAutoChild(item);
          }
          //Tìm tất cả con để chọn nhưng không nhận ID đơn vị con
          else {
            this.listData.push(item);
            //Chọn tất cả đơn vị con
            this.setValueChilds(item, true);
            //Lọc ra list id và item các đơn vị cha
            this.valueX = [];
            this.listData = [];
            this.dataSource.forEach((org) => {
              var parent = this.dataSource.find(
                (x) => x.OrganizationUnitID == org.ParentID
              );
              if (parent) {
                if (!parent.Selected && org.Selected) {
                  this.valueX.push(org.OrganizationUnitID);
                  this.listData.push(org);
                }
              } else if (org.Selected) {
                this.valueX.push(org.OrganizationUnitID);
                this.listData.push(org);
              }
            });
          }
        } else {
          item["Selected"] = false;
          this.$emit("remove", item);
          //Trường hợp xử lý riêng biệt cha con
          if (this.autochild) {
            this.valueX = this.valueX.filter(
              (x) => x != item.OrganizationUnitID
            );
            this.listData = this.listData.filter(
              (x) => x.OrganizationUnitID != item.OrganizationUnitID
            );
            //Bỏ chọn tất cả cha của đơn vị đang bỏ chọn
            this.unselectedParent(item);
            //hàm bỏ chọn tất cả đơn vị con và loại bỏ ID ra khỏi list data
            this.unselectChildsAutoChild(item);
          }
          //Xử lý trường hợp cha con ảnh hưởng đến nhau
          else {
            //Tìm tất cả con để bỏ chọn
            this.setValueChilds(item, false);
            //Bỏ chọn tất cả cha của đơn vị đang bỏ chọn
            this.unselectedParent(item);
            //Lọc ra list id và item các đơn vị cha
            this.valueX = [];
            this.listData = [];
            this.dataSource.forEach((org) => {
              var parent = this.dataSource.find(
                (x) => x.OrganizationUnitID == org.ParentID
              );
              if (parent) {
                if (!parent.Selected && org.Selected) {
                  this.valueX.push(org.OrganizationUnitID);
                  this.listData.push(org);
                }
              } else if (org.Selected) {
                this.valueX.push(org.OrganizationUnitID);
                this.listData.push(org);
              }
            });
          }
        }
        //Kiểm tra xem  bắn lên OrganizationUnitID hay OrgIDConvert
        if (this.useIDConvert && this.valueX) {
          var listOrgIDConvert = [];
          this.valueX.forEach((ele) => {
            var itemConvert = this.dataSource.find(
              (x) => x.OrganizationUnitID == ele
            );
            listOrgIDConvert.push(itemConvert.OrgIDConvert);
          });
          this.$emit("input", listOrgIDConvert);
        } else {
          this.$emit("input", this.valueX.length > 0 ? this.valueX : null);
        }
        this.$emit("listData", this.listData);
      }
    },
    /**
     * Hàm đệ quy bỏ chọn hoặc chọn tất cả đơn vị con
     * Created by cvcuong - 30/6/2021
     */
    setValueChilds(item, value) {
      var listChild = this.dataSource.filter(
        (x) => x.ParentID == item.OrganizationUnitID
      );
      if (listChild && listChild.length > 0) {
        listChild.forEach((org) => {
          org.Selected = value;
          this.setValueChilds(org, value);
        });
      }
    },
    /**
     * Hàm đệ quy chọn tất cả đơn vị con kèm theo loại bỏ khỏi danh sách value chế độ nhận ID đơn vị con
     * Created by cvcuong1 - 30/6/2021
     */
    selectChildsAutoChild(item) {
      var listChild = this.dataSource.filter(
        (x) => x.ParentID == item.OrganizationUnitID
      );
      if (listChild && listChild.length > 0) {
        listChild.forEach((org) => {
          org.Selected = true;
          this.valueX.push(org.OrganizationUnitID);
          this.listData.push(org);
          this.selectChildsAutoChild(org);
        });
      }
    },
    /**
     * Hàm đệ quy bỏ chọn tất cả đơn vị con kèm theo loại bỏ khỏi danh sách value chế độ nhận ID đơn vị con
     * Created by cvcuong1 - 30/6/2021
     */
    unselectChildsAutoChild(item) {
      var listChild = this.dataSource.filter(
        (x) => x.ParentID == item.OrganizationUnitID
      );
      if (listChild && listChild.length > 0) {
        listChild.forEach((org) => {
          org["Selected"] = false;
          this.valueX = this.valueX.filter((x) => x != org.OrganizationUnitID);
          this.listData = this.listData.filter(
            (x) => x.OrganizationUnitID != org.OrganizationUnitID
          );
          this.unselectChildsAutoChild(org);
        });
      }
    },
    /**
     * Hàm đệ quy bỏ chọn tất cả cha của đơn vị
     * Created by CVCUONG1 - 22/3/2021
     */
    unselectedParent(item) {
      var index = this.dataSource.findIndex(
        (x) => x.OrganizationUnitID == item.ParentID
      );
      if (index != -1) {
        //Bỏ chọn đơn vị cha hiện tại
        this.dataSource[index].Selected = false;
        this.unselectedParent(this.dataSource[index]);
      } else {
        return;
      }
    },
    /**
     * Hàm xóa đơn vị]
     * Created by CVCUONG1 - 1/3/2021
     */
    removeItem(item) {
      event.stopPropagation();
      if (this.isFirst) {
        this.valueX = this.valueX.filter((x) => x != item.OrganizationUnitID);
        this.listData = this.listData.filter(
          (x) => x.OrganizationUnitID != item.OrganizationUnitID
        );
        this.dataSource = this.dataSource.filter(
          (x) => x.OrganizationUnitID != item.OrganizationUnitID
        );
        this.internalText = this.valueX;
        this.validate(this.internalText);
        this.$emit("input", this.valueX);
        this.$emit("remove", item);
        this.$emit("listData", this.listData);
        return;
      }
      if (this.autochild) {
        this.valueX = this.valueX.filter((x) => x != item.OrganizationUnitID);
        this.listData = this.listData.filter(
          (x) => x.OrganizationUnitID != item.OrganizationUnitID
        );
        //Bỏ chọn tất cả cha của đơn vị đang bỏ chọn
        this.unselectedParent(item);
        //hàm bỏ chọn tất cả đơn vị con và loại bỏ ID ra khỏi list data
        this.unselectChildsAutoChild(item);
      } else {
        item["Selected"] = false;
        //Tìm tất cả con để bỏ chọn
        this.setValueChilds(item, false);
        //Bỏ chọn tất cả cha của đơn vị đang bỏ chọn
        this.unselectedParent(item);
        //Lọc ra list id và item các đơn vị cha
        this.valueX = [];
        this.listData = [];
        this.dataSource.forEach((org) => {
          var parent = this.dataSource.find(
            (x) => x.OrganizationUnitID == org.ParentID
          );
          if (parent) {
            if (!parent.Selected && org.Selected) {
              this.valueX.push(org.OrganizationUnitID);
              this.listData.push(org);
            }
          } else if (org.Selected) {
            this.valueX.push(org.OrganizationUnitID);
            this.listData.push(org);
          }
        });
      }
      this.internalText = this.valueX;
      this.validate(this.internalText);
      this.$emit("input", this.valueX);
      this.$emit("remove", item);
      this.$emit("listData", this.listData);
    },

    /**
     * Hàm lấy về danh sách đơn vị
     * Created by CVCUONG1 28/1/2021
     */
    getOrganizationUnitCommon(callback = null) {
      this.isFirst = false;
      var me = this;
      try {
        if (!this.getUnitChild) {
          OrganizationApi.getAllOU(
            this.subSystemCodeRole,
            this.actionRole,
            this.inactive
          )
            .then((res) => {
              me.isLoading = false;
              if (res.data && res.data.Success) {
                me.dataSource = JSON.parse(JSON.stringify(res.data.Data));
                if (
                  me.dataSource &&
                  me.dataSource.length > 0 &&
                  this.mode != "multiple" &&
                  this.showOptionNoChoose
                ) {
                  me.dataSource.unshift({
                    OrganizationUnitID: -9999,
                    OrganizationUnitName: i18n.tc("i18nCommon.NOT_SELECTED"),
                    IsOptionNoChoose: true,
                  });
                }
                if (
                  me.dataSource &&
                  me.dataSource.length > 0 &&
                  this.showOptionNoChoose &&
                  this.isUseEmptyOUOption
                ) {
                  me.dataSource.push({
                    OrganizationUnitID: -1,
                    OrganizationUnitName: i18n.tc("i18nCommon.Empty"),
                  });
                }
                me.listData = [];
                //Tìm cha cấp 1 và tạo trường search ảo tên không dấu
                me.dataSource.forEach((ele) => {
                  // ele["OrganizationUnitSearch"] = me.stringToSlug(
                  //   ele.OrganizationUnitName
                  // );
                  ele["OrganizationUnitSearch"] = ele.OrganizationUnitName;
                  if (
                    me.dataSource.findIndex(
                      (x) => x.OrganizationUnitID == ele.ParentID
                    ) == -1
                  ) {
                    ele["IsExpanded"] = true;
                    ele["ParentID"] = 0;
                  } else {
                    ele["IsExpanded"] = false;
                  }
                  if (
                    me.valueX &&
                    me.valueX.findIndex((x) => x == ele.OrganizationUnitID) !=
                      -1
                  ) {
                    ele["Selected"] = true;
                    me.listData.push(ele);
                  } else {
                    ele["Selected"] = false;
                  }
                });
                me.dataSource = JSON.parse(JSON.stringify(me.dataSource));
                callback && callback();
              } else {
                me.$notify._error();
              }
            })
            .catch((err) => me.$notify._error());
        } else {
          if (typeof this.parentID == "number") {
            me.parentID = me.parentID.toString();
          } else if (typeof me.parentID != "string") {
            me.parentID = me.parentID ? me.parentID.join(";") : "";
          }
          me.parentID = me.parentID ? me.parentID.replaceAll(",", ";") : "";
          OrganizationApi.getOrganizationUnitCommonById(
            me.parentID,
            me.subSystemCodeRole,
            me.actionRole,
            me.inactive
          )
            .then((res) => {
              me.isLoading = false;
              if (res.data && res.data.Success) {
                me.dataSource = JSON.parse(JSON.stringify(res.data.Data));
                me.listData = [];
                //Tìm cha cấp 1 và tạo trường search ảo tên không dấu
                me.dataSource.forEach((ele) => {
                  // ele["OrganizationUnitSearch"] = me.stringToSlug(
                  //   ele.OrganizationUnitName
                  // );
                  ele["OrganizationUnitSearch"] = ele.OrganizationUnitName;
                  if (
                    me.dataSource.findIndex(
                      (x) => x.OrganizationUnitID == ele.ParentID
                    ) == -1
                  ) {
                    ele["IsExpanded"] = true;
                    ele["ParentID"] = 0;
                  } else {
                    ele["IsExpanded"] = false;
                  }
                  if (
                    me.valueX &&
                    me.valueX.findIndex((x) => x == ele.OrganizationUnitID) !=
                      -1
                  ) {
                    ele["Selected"] = true;
                    me.listData.push(ele);
                  } else {
                    ele["Selected"] = false;
                  }
                });
                me.dataSource = JSON.parse(JSON.stringify(me.dataSource));
                callback && callback();
              } else {
                me.$notify._error();
              }
            })
            .catch((err) => me.$notify._error());
        }
      } catch (e) {
        me.$notify._error();
      }
    },
    /**
     * Hàm thay đổi giá trị có show đơn vị ngưng hoạt động không
     * Created by CVCUONG1 28/1/2021
     */
    changeInactive(val) {
      var me = this;
      me.inactive = val;
      me.getOrganizationUnitCommon(() => {
        me.$emit("inactive", val);
      });
    },
    /**
     * Hàm chọn các giá trị ban đầu khi khởi tạo
     * Created by CVCUONG1 29/1/2021
     */
    contentReady(e) {
      if (this.isFirst) {
        this.getOrganizationUnitCommon();
      }
    },
    /**
     * Hàm convert từ trường tiếng việt sang trường không dấu
     * Created by dmgiang 13/4/2021
     */
    stringToSlug(str) {
      str = str.toLowerCase();
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
      return str;
    },
    /**
     * Hàm xử lý khi click icon edit
     * created by pdthien 21.01.2021
     */
    clickEditBtn() {
      if (!this.isEditingMode) {
        this.dataSource = this.$function._cloneDeep(this.dataSource);
        this.oldValue = this.$function._cloneDeep(this.valueX);
        this.oldListData = this.$function._cloneDeep(this.listData);
        this.editingMode = !this.editingMode;
        this.$refs.input && this.$nextTick(() => this.$refs.input.focus());
        this.$store.dispatch("setEditingMode", true);
        this.$emit("clickEditBtn");
      }
    },
    /**
     * Hàm xử lý khi đóng chế độ edit
     * created by pdthien 21.01.2021
     */
    closeEditMode() {
      this.editingMode = false;
      this.valueX = this.$function._cloneDeep(this.oldValue);
      this.listData = this.$function._cloneDeep(this.oldListData);
      if (!this.isFirst) {
        this.dataSource.forEach((item) => {
          item.Selected = false;
        });
        this.listData &&
          this.listData.forEach((item) => {
            //hàm chọn tất cả đơn vị con của đơn vị đnag xét
            this.setValueChilds(item, true);
          });
      }
      this.$store.dispatch("setEditingMode", false);
      this.$emit("listData", this.listData);
      this.$emit("input", this.valueX);
      this.$emit("closeEditMode");
    },
    /**
     * Hàm xử lý khi lưu edit
     * created by pdthien 21.01.2021
     */
    saveEditMode() {
      if (!this.errorProvider.isValid) {
        this.$emit("onSaveData");
      }
    },
    /**
     * Hàm set editingMode = false
     */
    closeEditingMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
  flex-wrap: wrap;
  height: calc(100%);
  max-height: 180px;
  min-height: 34px;
  height: auto;
  padding: 0px 12px;
  border-radius: 4px;
  .selected-item {
    color: var(--text-primary-color);
    display: flex;
    align-items: center;
    border-radius: 4px;
    background-color: #e8eaef;
    padding-left: 8px;
    padding-right: 4px;
    margin: 2px 0;
    border: none;
    height: 26px;
    max-width: calc(100% - 5px);
    .item-text {
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .selected-item:not(:last-child) {
    margin-right: 4px;
  }
}
.mode-multiple .ms-organization-unit {
  position: relative;
  height: max-content;
  max-height: 100px;
}
.name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style lang="scss">
@import "@/assets/scss/controls/_variables.scss";

.dx-dropdowneditor-overlay .dx-popup-content {
  padding: 8px !important;
}
.ms-dropdown-box.dx-dropdowneditor-overlay .dx-popup-flex-height {
  max-height: none !important;
  .dx-popup-content {
    max-height: none !important;
  }
}
.dx-dropdowneditor-overlay .dx-popup-flex-height {
  min-width: 350px !important;
  right: 0px !important;
  left: initial !important;
}
.mode-multiple .dx-dropdowneditor-field-template-wrapper {
  overflow: auto;
  max-height: 100px;
}
// @media screen and (max-height: 768px) {
//   .dx-dropdowneditor-overlay {
//     .dx-popup-content {
//       height: 250px !important;
//     }
//   }
// }
.ms-organization-unit {
  width: 100%;
  height: 36px;
  .multiple-select {
    position: relative;
    .icon-organization-control {
      position: absolute;
      top: 4px;
      left: 8px;
    }
  }
}
.dx-popup-content {
  color: var(--text-primary-color);
  max-height: 500px;
}
.dx-treeview-toggle-item-visibility {
  top: 9px;
  left: 0px;
  width: 20px;
  height: 20px;
  -webkit-mask-position: -572px 0px;
  -moz-mask-position: -572px 0px;
  -ms-mask-position: -572px 0px;
  -o-mask-position: -572px 0px;
  mask-position: -572px 0px;
  margin-right: 5px;
  -webkit-mask-image: url("~@/assets/images/Icon_request.svg") !important;
  -moz-mask-image: url("~@/assets/images/Icon_request.svg") !important;
  -ms-mask-image: url("~@/assets/images/Icon_request.svg") !important;
  -o-mask-image: url("~@/assets/images/Icon_request.svg") !important;
  mask-image: url("~@/assets/images/Icon_request.svg") !important;
  -webkit-mask-repeat: no-repeat;
  -moz-mask-repeat: no-repeat;
  -ms-mask-repeat: no-repeat;
  -o-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  background-color: #666666;

  &::before {
    content: none;
  }

  &.dx-treeview-toggle-item-visibility-opened {
    -webkit-mask-position: -592px 0px;
    -moz-mask-position: -592px 0px;
    -ms-mask-position: -592px 0px;
    -o-mask-position: -592px 0px;
    mask-position: -592px 0px;
  }
}
.dx-treeview-item {
  margin: 1px 0px 1px 10px;
  border-radius: 4px;
  min-height: 36px;
  align-items: center;
  display: flex;
  padding: 0px;
}
.ms-organization-unit {
  .dx-dropdowneditor.dx-dropdowneditor-active .dx-dropdowneditor-icon {
    width: 20px;
    height: 20px;
    -webkit-mask-position: -144px -24px;
    -moz-mask-position: -144px -24px;
    -ms-mask-position: -144px -24px;
    -o-mask-position: -144px -24px;
    mask-position: -144px -24px;
    margin-right: 0px;
    -webkit-mask-image: url("~@/assets/images/Icon.svg") !important;
    -moz-mask-image: url("~@/assets/images/Icon.svg") !important;
    -ms-mask-image: url("~@/assets/images/Icon.svg") !important;
    -o-mask-image: url("~@/assets/images/Icon.svg") !important;
    mask-image: url("~@/assets/images/Icon.svg") !important;
    -webkit-mask-repeat: no-repeat;
    -moz-mask-repeat: no-repeat;
    -ms-mask-repeat: no-repeat;
    -o-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    background-color: #868ca4;
  }
  .dx-dropdowneditor-icon {
    width: 20px;
    height: 20px;
    -webkit-mask-position: -144px -24px;
    -moz-mask-position: -144px -24px;
    -ms-mask-position: -144px -24px;
    -o-mask-position: -144px -24px;
    mask-position: -144px -24px;
    margin-right: 0px;
    -webkit-mask-image: url("~@/assets/images/Icon.svg") !important;
    -moz-mask-image: url("~@/assets/images/Icon.svg") !important;
    -ms-mask-image: url("~@/assets/images/Icon.svg") !important;
    -o-mask-image: url("~@/assets/images/Icon.svg") !important;
    mask-image: url("~@/assets/images/Icon.svg") !important;
    -webkit-mask-repeat: no-repeat;
    -moz-mask-repeat: no-repeat;
    -ms-mask-repeat: no-repeat;
    -o-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    background-color: #868ca4 !important;
  }
}

.dx-dropdowneditor-button .dx-button-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dx-texteditor.dx-editor-outlined {
  border-radius: 4px;
  &:hover {
    border-color: var(--input-hover-border-color);
  }
}
.dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item {
  background-color: var(--white);
  color: var(--black);
}
.dx-treeview-item-without-checkbox.dx-state-focused > .dx-treeview-item {
  background-color: var(--white);
  color: var(--black);
}
.dx-treeview-item.dx-state-hover {
  background-color: var(--primary-bg) !important;
  color: var(--black);
}
.dx-texteditor.dx-state-focused.dx-editor-outlined {
  border-color: var(--input-hover-border-color);
}
// style validate error
.isValidOrg {
  .dx-texteditor.dx-editor-outlined {
    border-color: $input-error-border-color;
  }
  .dx-dropdowneditor-icon {
    display: none;
  }
}
.icon-input-tree-select {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.p-b-42 {
  padding-bottom: 42px;
}
@media only screen and (max-height: 900px) {
  .dropdown-content-organization {
    height: 312px !important;
  }
}
@media only screen and (max-height: 768px) {
  .dropdown-content-organization {
    height: 285px !important;
  }
}
.dropdown-content-organization {
  // height: 350px !important;
  padding: 12px;
  position: relative;
  .org-inactive {
    margin: 0 12px;
    margin-bottom: 8px;
    padding: 0 4px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 36px;
    display: flex;
    align-items: center;
    background-color: var(--primary-bg);
    border-radius: 4px;
  }
  .color-active {
    color: var(--primary);
  }
}
.item-org {
  color: var(--text-primary-color);
  padding: 8px;
  width: 100%;
  height: 100%;
}
.org-active {
  background-color: var(--primary-bg);
  border-radius: 4px;
  color: var(--primary);
}

.dx-list-item {
  border-top: none;
  &:last-of-type {
    .item-wrap-ms-organization .item-wrap-detail {
      border: none !important;
    }
  }
}
.ms-organization-unit-1 {
  .dx-list-item-content {
    padding: 0px !important;
  }
}
.dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened {
  margin-top: -1px;
}
.dx-treeview-toggle-item-visibility {
  margin-top: -1px;
}
.dx-list-item {
  &.dx-state-focused {
    background-color: var(--primary-bg) !important;
    color: var(--primary) !important;
  }
  .item-wrap-ms-organization {
    display: flex;
    align-items: center;
    height: 67px;
    // padding: 0px 24px !important;
    width: 100% !important;
  }
  .item-wrap-ms-organization:hover {
    background-color: var(--primary-bg);
  }

  .item-wrap-ms-organization:focus {
    background-color: transparent;
  }
  .item-wrap-ms-organization .item-wrap-detail {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
  }
  .item-wrap-detail:first-of-type {
    border-top: none !important;
  }
  .item-name {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .item-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #ccc;
    margin-right: 10px;
  }
}
.hide-content {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}
.text-box {
  display: flex;
  .dx-texteditor-input {
    color: #212121 !important;
  }
  .dx-placeholder {
    color: var(--text-placeholder-color) !important;
  }
  .dx-state-disabled.dx-widget {
    opacity: 1;
  }
  .icon-organization-control {
    margin: 4px 0px 4px 8px;
  }
}
.m-t-7 {
  margin-top: 7px;
}
.h-0 {
  height: 0px !important;
}
</style>
